import * as _ from 'lodash'
import { Instance, types } from 'mobx-state-tree'
import { TEETH_INDICES } from '../calculator/Constants'

export const Requirement = types
  .model('Requirement', {
    jaw: types.optional(types.enumeration(['upper', 'lower']), 'upper'),
    missingTeeth: types.array(types.number),
    noTeeth: types.optional(types.boolean, false),
    fullReplacementType: types.optional(types.enumeration(['removable', 'non_removable', 'all_on_4', 'all_on_6']), 'removable'),
    implantCount: types.optional(types.number, 4),
    implantAttachmentType: types.optional(types.enumeration(['locator', 'telescope', 'bridge']), 'locator'),
    material: types.optional(types.enumeration(['normal', 'premium']), 'premium'),
    boneGrafting: types.optional(types.enumeration(['yes', 'no', 'maybe']), 'no'),
    boneGraftingType: types.optional(types.enumeration(['sinus_lifting_onesided', 'sinus_lifting_twosided', 'normal']), 'normal'),
    skipped: types.optional(types.boolean, false)
  })
  .views(self => ({
    get sortedMissingTeeth () {
      return self.missingTeeth.slice().sort()
    },
    get allOn4 () {
      return self.fullReplacementType === 'all_on_4' || self.fullReplacementType === 'all_on_6'
    },
    // maximumMissingTeethReached () {
    //   return self.missingTeeth.length >= 6
    // },
    serializeForAPI () {
      const data: any = {
        no_teeth: self.noTeeth,
        full_replacement_type: self.fullReplacementType,
        missing_teeth: Array.from(self.missingTeeth),
        implant_count: self.implantCount,
        implant_attachment_type: self.implantAttachmentType,
        material: self.material,
        bone_grafting_required: self.boneGrafting,
        bone_grafting_type: self.boneGraftingType
      }
      return data
    },
    hasRequirements () {
      return self.missingTeeth.length || self.noTeeth
    }
  }))
  .actions(self => {
    const actions = {
      setMaterial: (material: 'normal'|'premium') => {
        self.material = material
      },
      setBoneGrafting: (boneGrafting: 'yes'|'no'|'maybe') => {
        self.boneGrafting = boneGrafting
      },
      setBoneGraftingType: (boneGraftingType: 'sinus_lifting_onesided'|'sinus_lifting_twosided'|'normal') => {
        self.boneGraftingType = boneGraftingType
      },
      setFullReplacementType: (fullReplacementType: 'removable'|'non_removable'|'all_on_4'|'all_on_6') => {
        self.fullReplacementType = fullReplacementType
        if (fullReplacementType === 'non_removable' || fullReplacementType === 'all_on_6') {
          self.implantCount = 6
        } else {
          self.implantCount = 4
        }
      },
      setImplantCount: (implantCount: number) => {
        self.implantCount = implantCount
      },
      setSkipped: (skipped: boolean) => {
        self.skipped = skipped
      },
      setImplantAttachmentType: (implantAttachmentType: 'locator'|'telescope'|'bridge') => {
        if (implantAttachmentType !== 'locator' && self.implantCount <= 4) {
          self.implantCount = 4
        }
        self.implantAttachmentType = implantAttachmentType
      },
      setNoTeeth: (noTeeth: boolean) => {
        self.noTeeth = noTeeth
      },
      toggleToothMissing: (toothIndex: number) => {
        const toothPosition = self.missingTeeth.indexOf(toothIndex)
        if (toothPosition === -1) {
          // if (self.maximumMissingTeethReached()) return
          self.missingTeeth.push(toothIndex)
        } else {
          self.missingTeeth.splice(toothPosition, 1)
        }
        if (!_.difference(TEETH_INDICES[self.jaw].filter(t => t % 10 !== 7), self.missingTeeth.slice()).length) {
          self.noTeeth = true
        }
      },
      isToothMissing: (toothIndex: number): boolean => {
        return self.missingTeeth.indexOf(toothIndex) !== -1
      }
    }
    return actions
  })

export type RequirementInstance = Instance<typeof Requirement>
